import axios from 'axios';
import { TAddress } from '@/redux/slices/user/types.ts';

export const apiBilling = {
  getAddresses: async () =>
    await axios
      .get('/service/account/reseller-address')
      .then((res) => res.data?.result || []),
  postAddress: async (address: TAddress) =>
    await axios
      .post('/service/account/reseller-address', address)
      .then((res) => res.data.result),
  getPaymentOptions: async (resellerUuid: string) =>
    await axios
      .get(`/service/account/reseller/${resellerUuid}/payment-method`)
      .then((res) => res.data.result),
  getCallCredit: async () =>
    await axios.get('/service/account/balance').then((res) => res.data.result),
  getPaymentIntentSecret: async () =>
    await axios
      .get('/svc/account/payment/intent')
      .then((res) => res.data.client_secret),
  getPaypalClientToken: async () =>
    await axios
      .get('/account/member/payment/paypal/?version=2')
      .then((res) => res.data.token),
};

export default apiBilling;
